/**
 * Sign-in providers besides email + password (Supabase Auth's OAuth). The API
 * lists the ones the owner has configured (LOREVOK_OAUTH_PROVIDERS, served as
 * `oauth_providers` by GET /api/site-config) and the web shows a button for
 * each. Nothing else may appear in that list: every provider needs its own
 * app, consent screen and Privacy Policy wording (docs/DEPLOY.md).
 */
export const OAUTH_PROVIDERS = ["google", "discord"] as const;

export type OAuthProvider = (typeof OAUTH_PROVIDERS)[number];

export function isOAuthProvider(raw: unknown): raw is OAuthProvider {
  return typeof raw === "string" && (OAUTH_PROVIDERS as readonly string[]).includes(raw);
}

/**
 * The known providers in `raw` — a comma/space-separated list (the env
 * variable) or an array (the site-config answer) — lower-cased, first
 * occurrence kept, anything unknown dropped. Anything else is an empty list.
 */
export function parseOAuthProviders(raw: unknown): OAuthProvider[] {
  const items = typeof raw === "string" ? raw.split(/[\s,]+/) : Array.isArray(raw) ? raw : [];
  const found: OAuthProvider[] = [];
  for (const item of items) {
    const name = typeof item === "string" ? item.trim().toLowerCase() : "";
    if (isOAuthProvider(name) && !found.includes(name)) found.push(name);
  }
  return found;
}
